module.exports = __webpack_public_path__ + "img/download_logo.7809d71f.png";